import axios from 'axios';
import get from 'lodash/get';

import { getFileNameFromAwsUrl } from '@/files';

export default async ({ modifiedModel, topicProperties, handleBackendErrors }) => {
  const topicId = get(topicProperties, 'data.id', null);
  const versionId = get(topicProperties, 'data.topic_id', null);
  const copiedModel = { ...modifiedModel, id: topicId };

  if (copiedModel?.cover_art && typeof copiedModel.cover_art === 'string') {
    copiedModel.cover_art = {
      url: modifiedModel.cover_art,
      name: getFileNameFromAwsUrl({ url: modifiedModel.cover_art }),
    };
  }

  const url = `/api/admin/videos/topics/${topicId}${versionId ? `?version_id=${versionId}` : ''}`;

  try {
    await axios.put(url, { data: copiedModel });
  } catch (error) {
    handleBackendErrors(error);
  }
};
